import VisitorAvatar from './VisitorAvatar';
import VisitorRowActions from './VisitorRowActions';
import { VisitorTypeBadge, VisitorStatusBadge, IdProofBadge } from './VisitorBadges';
import { VisitorLoader, VisitorEmptyState } from './VisitorListStates';
import { fmtDate, fmtPhone } from '../visitorConstants';

const COLUMNS = ['Visitor', 'Phone', 'Type', 'ID Proof', 'Visits', 'Last Visit', 'Status'];

const VisitorTable = ({ rows, loading, actions, empty }) => (
    <div className="tw-overflow-x-auto">
        <table className="tw-w-full tw-text-xs">
            <thead>
                <tr className="tw-bg-gray-50 tw-border-b tw-border-gray-100">
                    {COLUMNS.map(col => (
                        <th key={col} className="tw-text-left tw-px-4 tw-py-3 tw-font-bold tw-text-gray-700 tw-text-[11px]">
                            {col}
                        </th>
                    ))}
                    <th className="tw-text-right tw-px-4 tw-py-3 tw-font-bold tw-text-gray-700 tw-text-[11px]">Action</th>
                </tr>
            </thead>
            <tbody>
                {loading && (
                    <tr><td colSpan={COLUMNS.length + 1}><VisitorLoader /></td></tr>
                )}

                {!loading && rows.length === 0 && (
                    <tr><td colSpan={COLUMNS.length + 1}><VisitorEmptyState {...empty} /></td></tr>
                )}

                {!loading && rows.map(v => (
                    <tr
                        key={v.visitor_id}
                        onClick={() => actions.onView(v)}
                        className="tw-border-b tw-border-gray-50 hover:tw-bg-slate-50/50 tw-transition-colors tw-cursor-pointer"
                    >
                        <td className="tw-px-4 tw-py-2.5">
                            <div className="tw-flex tw-items-center tw-gap-2.5">
                                <VisitorAvatar visitor={v} size={34} />
                                <div className="tw-min-w-0">
                                    <p className="tw-mb-0 tw-font-semibold tw-text-gray-800 tw-truncate" title={v.name}>{v.name}</p>
                                    <p className="tw-mb-0 tw-mt-0.5 tw-text-[10px] tw-text-gray-500 tw-truncate" title={v.company_name || v.email || ''}>
                                        {v.company_name || v.email || '—'}
                                    </p>
                                </div>
                            </div>
                        </td>
                        <td className="tw-px-4 tw-py-2.5 tw-text-gray-800 tw-font-mono tw-whitespace-nowrap">{fmtPhone(v.phone)}</td>
                        <td className="tw-px-4 tw-py-2.5"><VisitorTypeBadge value={v.visitor_type} /></td>
                        <td className="tw-px-4 tw-py-2.5 tw-text-gray-700">
                            <IdProofBadge type={v.id_proof_type} number={v.id_proof_number} withNumber />
                        </td>
                        <td className="tw-px-4 tw-py-2.5">
                            <span className="tw-inline-flex tw-items-center tw-justify-center tw-min-w-[22px] tw-px-1.5 tw-py-0.5 tw-rounded tw-bg-gray-100 tw-text-gray-700 tw-font-semibold tw-text-[11px]">
                                {v.visit_count ?? 0}
                            </span>
                        </td>
                        <td className="tw-px-4 tw-py-2.5 tw-text-gray-700 tw-whitespace-nowrap">{fmtDate(v.last_visit_at)}</td>
                        <td className="tw-px-4 tw-py-2.5"><VisitorStatusBadge visitor={v} /></td>
                        {/* The row itself opens the profile, so the action cell has
                            to stop the click from bubbling into that navigation. */}
                        <td className="tw-px-4 tw-py-2.5 tw-text-right" onClick={e => e.stopPropagation()}>
                            <VisitorRowActions visitor={v} {...actions} />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

export default VisitorTable;
